import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=08568dda&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=08568dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08568dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08568dda')) {
      api.createRecord('08568dda', component.options)
    } else {
      api.reload('08568dda', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=08568dda&scoped=true&", function () {
      api.rerender('08568dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22Y9J5gGaYK0t/JS/comp/SearchFilterTokens.vue"
export default component.exports